module.exports = __webpack_public_path__ + "img/bar.8346ab68.svg";